import { FC, useState } from "react";
import PlusCircleIcon from "public/plus-circle-azure.svg";

const ExemptionsEstimateCardExpandSection = () => {
	const [expanded, setExpanded] = useState(false);

	return (
		<div className="exemptions-box-expand-btn">
			<div
				className="appeal-savings-box-expand-label-container"
				onClick={() => setExpanded(previouslyExpanded => !previouslyExpanded)}>
				<PlusCircleIcon
					className={`appeal-savings-box-expand-icon ${
						expanded ? "appeal-savings-box-expand-icon-expanded" : ""
					}`}
				/>
				<p className="appeal-savings-box-expand-label">What does this mean?</p>
			</div>
			{expanded && (
				<div>
					<p className="sm exemptions-box-expand-btn-inner-info">
						Based on our data and information you’ve shared, we think your
						property was eligible for the homestead tax break in previous years.
						In most cases, you're able to receive a refund for the savings
						you've missed. This varies county by county, but generally it covers
						the previous 2 years of your primary residence.
					</p>
				</div>
			)}
		</div>
	);
};

export default ExemptionsEstimateCardExpandSection;
